import { createContext, useContext } from 'react';
import type { CurrencyCodeType } from '@shared/utils/currency/currency.types';

export type TravelCurrencyPickHandler = (currencyCode: CurrencyCodeType) => void;

/**
 * Replaces what every `TravelCurrencySelector` below it does when someone picks a currency.
 *
 * Without a provider, a pick stores the currency and reloads the page. Provide a handler to run a step of your own
 * first, such as a question; the handler then applies the pick itself. A selector given its own `onChange` ignores
 * this context.
 */
export const TravelCurrencyPickHandlerContext = createContext<TravelCurrencyPickHandler | null>(null);

export const useTravelCurrencyPickHandlerFromContext = (): TravelCurrencyPickHandler | null => useContext(TravelCurrencyPickHandlerContext);
